import { render, staticRenderFns } from "./Associates.vue?vue&type=template&id=6fb57000&scoped=true"
import script from "./Associates.vue?vue&type=script&lang=js"
export * from "./Associates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb57000",
  null
  
)

export default component.exports